import React from 'react';
import './InfoCardMolecule.scss';

export type InfoCardVariant = 'info' | 'success' | 'warning' | 'purple' | 'gradient-blue' | 'gradient-purple';
export type InfoCardSize = 'compact' | 'normal' | 'large';

export interface InfoCardMoleculeProps {
  title: string;
  subtitle?: string;
  value?: string | number;
  icon?: React.ReactNode;
  variant?: InfoCardVariant;
  size?: InfoCardSize;
  className?: string;
  onClick?: () => void;
}

const InfoCardMolecule: React.FC<InfoCardMoleculeProps> = ({
  title,
  subtitle,
  value,
  icon,
  variant = 'info',
  size = 'normal',
  className = '',
  onClick,
}) => {
  const variantClass = `info-card--variant-${variant}`;
  const sizeClass = `info-card--size-${size}`;
  const clickableClass = onClick ? 'info-card--clickable' : '';
  const cardClassName = `info-card-molecule ${variantClass} ${sizeClass} ${clickableClass} ${className}`;

  return (
    <button
      type="button"
      className={cardClassName}
      onClick={onClick}
    >
      <div className="info-card-content">
        {icon && <div className="info-card-icon">{icon}</div>}
        <div className="info-card-text">
          <h3 className="info-card-title">{title}</h3>
          {subtitle && <p className="info-card-subtitle">{subtitle}</p>}
          {value !== undefined && (
            <div className="info-card-value">{value}</div>
          )}
        </div>
      </div>
    </button>
  );
};

export default InfoCardMolecule;